<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent :max-width="width ? width : 1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="subheadline">Estadio Nuevo</span>
          <v-layout row wrap class="item-group">
            <v-flex>
            <!--campos arbitro-->
             <v-text-field v-model="description"
             required
             :error-messages="getRequiredErrors('description')"
             label="Descripción">
             </v-text-field>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-btn color="primary" @click="closeDialog">Volver</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../../mixins/createEntityMixin'

export default {
  mixins: [validationMixin, createEntityMixin],
  props: {
    reserva: Boolean,
    width: String
  },

  validations: {
    description: { required }
  },

  components: {},

  data () {
    return {
      dialog: false,
      createPath: 'informe-auditoria/create-stadium',
      isEditing: false,
      description: '',
      category: null
    }
  },
  methods: {
    isValidForm () {
      return !this.$v.$invalid
    },
    getPayload () {
      return {
        description: this.description,
        capacity: 0,
        city: 1,
        category: this.category

      }
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    postSuccessfulSubmit (response) {
      this.$emit('estadioCreado', response)
      this.description = ''
      this.saving = false
      this.dialog = false
    },
    goBack () {
      this.goBackConfirmed = true
      this.$router.go()
    }
  },
  created () {
    if (this.reserva) {
      this.category = 1
    } else {
      this.category = 0
    }
  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.6em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
